<template>
  <div class="rm-screen">
    <div v-if="dayLoading" class="rm-empty">
      <v-progress-circular indeterminate color="#c2410c"></v-progress-circular>
    </div>

    <template v-else>
      <group-mobile-shift-chips v-model="selectedShift" :shifts="shifts"></group-mobile-shift-chips>

      <div v-if="!slips.length" class="rm-empty">
        <template v-if="searchText">{{ $t("report_mobile.no_results_for", { search: $store.state.report.filters.search }) }}</template>
        <template v-else>
          <v-icon size="40" color="#8a817a">mdi-food-off</v-icon>
          {{ $t("no_orders") }}
        </template>
      </div>

      <template v-else>
        <div class="rm-stats rm-stats--pair">
          <div class="rm-stat rm-stat--inverse">
            <span class="rm-stat__label">{{ $t("report_desktop.workers") }}</span>
            <span class="rm-stat__value rm-num">{{ workerTotal }}</span>
          </div>
          <div class="rm-stat">
            <span class="rm-stat__label">{{ $t("report_desktop.total_meals") }}</span>
            <span class="rm-stat__value rm-num">{{ mealTotal }}</span>
          </div>
        </div>
        <group-mobile-slip-list :slips="listSlips" :shift="Number(selectedShift)" :layout="0"></group-mobile-slip-list>
      </template>
    </template>
  </div>
</template>

<script>
import CompanyReportTabOrders from "@/components/company/reports/tabs/CompanyReportTabOrders.vue";
import GroupMobileShiftChips from "@/components/report/mobile/screens/group/GroupMobileShiftChips.vue";
import GroupMobileSlipList from "@/components/report/mobile/screens/group/GroupMobileSlipList.vue";
import hasCompanyGroupOrderSlips from "../../hasCompanyGroupOrderSlips";

/**
 * Mobilni "Naručeno" firme tipa "grupa": jedna smena (oznake smena na vrhu), radnici sa obrocima po grupama jela
 * (za period i po danu). Firme i period su u zaglavlju, pretraga u lupi. Nasleđuje učitavanje, štampu i Excel iz
 * starog taba.
 */
export default {
  name: "CompanyMobileGroupOrdered",
  extends: CompanyReportTabOrders,
  mixins: [hasCompanyGroupOrderSlips],
  components: { GroupMobileShiftChips, GroupMobileSlipList },
  computed: {
    listSlips() {
      return this.slips.map((slip) => ({
        key: slip.key,
        name: this.isRange ? `${slip.name} · ${slip.dateText}` : slip.name,
        initials: slip.initials,
        no: slip.userId,
        categories: slip.categories,
      }));
    },
  },
};
</script>
